// Module
var code = `<div id="t-header"></div> <div class="main col-sm-24 sc-px-0"> <div ui-view="" class="row h-100 d-block sc-mx-0"> </div> </div> <div id="t-side-menu"></div> <div id="footer"></div> `;
// Exports
var _module_exports =code;;
var path = '/layouts/defaultLayout.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;